import { NOTE_TEMPLATES_DATA_SUCCESS, SELECTED_NOTE_TEMPLATE_DATA_SUCCESS, CHANGE_NOTE_TYPE_SUCCESS, RESET_NOTE_CREATION_STATE, SAVE_NOTE_ERROR, TOGGLE_CREATE_NOTE_LOADING, DISCARD_NOTE_REDIRECT_URL,RESET_WORKKARD_DETAIL_DATA,GET_TIMEZONE_BY_ZIP_SUCCESS, NOTE_CREATE_SUCCESSFULLY, GET_WORKKARD_ACTIVITY_NOTE_FILES_SUCCESS } from "../actions/actionConstants";
import { CharConstants } from '../constants';

const initialState = {
    saveNoteErrorText: "",
    SaveNoteErrorTextByViews:"",
    templateType: CharConstants.Activity,
    noteTemplates: [],
    isLoading: false,
    noteData: {},
    timeZoneValue:"",
    filesData:[]
}

export default function (state = initialState, action) {
    switch (action.type) {
        case NOTE_TEMPLATES_DATA_SUCCESS: {
           return Object.assign({}, state, action.payload);
        }
        case GET_WORKKARD_ACTIVITY_NOTE_FILES_SUCCESS: {
           return Object.assign({}, state, action.payload);
        }
        case SELECTED_NOTE_TEMPLATE_DATA_SUCCESS: {
            return Object.assign({}, state, action.payload);
        }
        case CHANGE_NOTE_TYPE_SUCCESS:{
            const selectedNoteDraftandTemplateData = Object.assign({}, state.selectedNoteDraftandTemplateData, { NoteTemplate: action.payload })
            return Object.assign({}, state, { selectedNoteDraftandTemplateData });
        }
        case RESET_NOTE_CREATION_STATE:
            return  initialState;
        case SAVE_NOTE_ERROR:
            return Object.assign({}, state, action.payload);
        case TOGGLE_CREATE_NOTE_LOADING:
            return Object.assign({}, state, action.payload );
        case DISCARD_NOTE_REDIRECT_URL:
            return Object.assign({}, state, action.payload);
        case RESET_WORKKARD_DETAIL_DATA:
            return Object.assign(
                {},
                initialState
            );
        case GET_TIMEZONE_BY_ZIP_SUCCESS:
            return Object.assign({},state,{timeZoneValue:action.payload.timeZoneValue})
        default:
            return state;
    }
}